import aliPayIcon from '@/assets/img/ali-pay-icon.png';
import wxPayIcon from '@/assets/img/wx-pay-icon.png';
import aliPayHuaBeiIcon from '@/assets/img/huabei-pay-icon.png';

// 性别选项
export const sexOptions = [
  {
    label: '男',
    value: 0,
  },
  {
    label: '女',
    value: 1,
  },
  {
    label: '保密',
    value: 3,
  },
];

// 没有获取到在线客服地址时，默认使用这个地址
export const defaultOnlineCallUrl = 'https://cdn-hs.yuaiweiwu.com/fe-native/web/qiyu-kefu.html';

// 设置页面配置
export const settingConfig = [
  {
    title: '服务协议',
    key: 'serviceAgreement',
  },
  {
    title: '隐私政策',
    key: 'privacyPolicy',
  },
  {
    title: '关于我们',
    key: 'aboutUs',
  },
  {
    title: '设置密码',
    key: 'setPassword',
  },
  {
    title: '修改绑定手机号',
    key: 'changePhone',
  },
  {
    title: '注销账号',
    key: 'cancelAccount',
  },
]

// 课节类型
export enum PeriodTypeEnum {
  ALL = 0,
  BIG_CLASS = 2, //大班课
  VIDEO_CLASS = 5, //点播课
  PICTURE_CLASS = 10, // 图文课
  DOUBLE_TEACHER_CLASS = 16, //双师课
  GP = 18, //课时包(AI英语)
  AI_MATH = 23, //互动课(AI数学)
}

export const PeriodType = {
  [PeriodTypeEnum.ALL]: '全部',
  [PeriodTypeEnum.BIG_CLASS]: '直播课',
  [PeriodTypeEnum.VIDEO_CLASS]: '点播课',
  [PeriodTypeEnum.PICTURE_CLASS]: '图文课',
  [PeriodTypeEnum.DOUBLE_TEACHER_CLASS]: '双师课',
  [PeriodTypeEnum.GP]: '课时包',
  [PeriodTypeEnum.AI_MATH]: '互动课',
};

// 业务类型
export enum BizTypeEnum {
  PUBLIC_COURSE = 0,
  AI_ENGLISH = 10,
  AI_MATH = 11,
  WAR = 12,
  GMT = 13
}

export const BizType = {
  [BizTypeEnum.PUBLIC_COURSE]: '大班课',
  [BizTypeEnum.AI_ENGLISH]: 'AI英语',
  [BizTypeEnum.AI_MATH]: 'AI数学',
};

export const ReportBizEnum = {
  [BizTypeEnum.AI_ENGLISH]: 'GP',
  [BizTypeEnum.AI_MATH]: 'NEXT',
  [BizTypeEnum.PUBLIC_COURSE]: 'PUBLIC',
}

export enum CouponScopTypeEnum {
  ALL = 1, // 全部
  COURSE = 3, // 普通课程
  COMBINE = 5, // 组合课程
}

export enum CouponDisTypeEnum {
  ORDER = 0, // 订单优惠券
  COURSE = 1, // 课程优惠券
}

export enum CourseTypeEnum {
  /** 普通课程 */
  Normal = 1,
  /** 课程包类型 */
  CoursePackage = 2,
  /** 课程实物 */
  CourseEntry = 3,
}

export enum CourseClassifyEnum {
  SHORT_TERM = 2, // 短期班
  LONG_TERM = 3, // 长期班
}

export enum CourseStatusEnum {
  /** 未开课 */
  NOT_STARTED = 0,
  /** 开课中 */
  IN_PROGRESS = 1,
  /** 已下课 */
  COMPLETED = 2,
}

export enum AppointmentStatusEnum {
  /** 不可预约 */
  UNABLE_APPOINTMENT = 0,
  /** 未预约 */
  NOT_APPOINTMENT = 1,
  /** 已预约 */
  APPOINTMENT = 2,
}

/**
 * 订单状态
 */
export enum OrderStatusEnum {
  ALL = 0, //全部订单
  TRADING = 1, //交易中
  TRADE_COMPLETE = 2, //交易完成
  TRADE_CLOSE = 3, //交易关闭
}

export const OrderStatus = {
  [OrderStatusEnum.TRADING]: '交易中',
  [OrderStatusEnum.TRADE_COMPLETE]: '交易完成',
  [OrderStatusEnum.TRADE_CLOSE]: '交易关闭',
};


export enum PayStatusEnum {
  NONE = 0,
  UNPAID = 1, //待付款
  PAID = 2, //已付款
  REFUND_APPLING = 3, //退款申请中
  REFUNDING = 4, //退款中
  REFUNDED = 5, //退款成功
  REFUND_FAIL = 6, //退款失败
}

export const PayStatus = {
  [PayStatusEnum.NONE]: '',
  [PayStatusEnum.UNPAID]: '待支付',
  [PayStatusEnum.PAID]: '已支付',
  [PayStatusEnum.REFUND_APPLING]: '退款申请中',
  [PayStatusEnum.REFUNDING]: '退款中',
  [PayStatusEnum.REFUNDED]: '退款成功',
  [PayStatusEnum.REFUND_FAIL]: '退款失败',
};

// 查询时，订单类型
export enum OrderTypeEnum {
  NONE = 0,
  OTO = 1, //一对一
  COURSE = 2, //课程
  GOODS = 4, //商品
  GROUP = 5, //拼团
  PERIODS_PACKAGE = 6, //课节包
  COURSE_PACKAGE = 7, //课程包
  CLASSES = 8, //班级
  VIP = 9, //会员
  PAPER_PACKAGE = 10, // 套卷
  EBOOK = 11,// 电子书
}

// 接口返回时，订单类型
export enum OrderTypeRespEnum {
  NONE = 0,
  NORMAL = 1, //普通
  DONATE = 2, //赠送
  STUDY_CARD = 3, //学习卡
  GROUP = 5, //拼团
  INTEGRAL = 6, //积分
  LIANBAO = 7, //联报
  COURSE_PACKAGE = 8, //课程包
  CLOCKIN = 9, // 打卡
}

/**
 * 播放功能，老项目迁移过来
 */

// course_type : 1 普通课程 2 班级课程 3 公开课
export enum NewCourseTypeEnum {
  ALL = 0,
  COMMON_COURSE = 1,
  CLASS_COURSE = 2,
  PUBLIC_COURSE = 3,
  BILLING_COURSE = 4,
  EBOOK_TYPE = 22,
}

export const NewCourseType = {
  [NewCourseTypeEnum.ALL]: '全部',
  [NewCourseTypeEnum.COMMON_COURSE]: '普通课程',
  [NewCourseTypeEnum.CLASS_COURSE]: '班级课程',
  [NewCourseTypeEnum.PUBLIC_COURSE]: '公开课',
  [NewCourseTypeEnum.BILLING_COURSE]: '计费约课',
  [NewCourseTypeEnum.EBOOK_TYPE]: '电子书',
};


export enum RoomTypeEnum {
  OTHER = 1,
  SMALLROOM = 2,
  CLASS = 3,
  OTOANDOTC,
  CLASSMEETING,
  PUBLICCOURSE = 7,
}

export enum ShopTypeEnum {
  NONE = 0,
  NORMAL_COURSE = 1, //普通课程
  /** @deprecated */
  CLASS_COURSE = 2, //班级课程
  /** @deprecated */
  PUBLIC_CLASS = 3, //公开课
  /** @deprecated */
  OTO_CLASS = 4, //一对一
  /** @deprecated */
  VIDEO_CLASS = 5, //废弃了 暂保留
  /** @deprecated */
  FACE_CLASS = 7, //废弃了 暂保留
  /** @deprecated */
  AUDIO_CLASS = 8, //废弃了 暂保留
  /** @deprecated */
  SYSTEM_CLASS = 9, //废弃了 暂保留
  /** @deprecated */
  PICTURE_CLASS = 10, //废弃了 暂保留
  /** @deprecated */
  BALANCE = 11, // 充值余额
  GOODS = 12, // 实物商品
  /** @deprecated */
  LIBRARY = 13, // 文库
  /** @deprecated */
  GROUP_CLASS = 15, //废弃了 暂保留
  /** @deprecated */
  DOUBLE_TEACHER_CLASS = 16,
  PERIODS_PACKAGE = 17, // 课节包
  /** @deprecated */
  CLOCK_IN = 18, // 打卡
  /** @deprecated */
  CLASSES = 19, // 班级
  /** @deprecated */
  VIP = 20, // 会员
  /** @deprecated */
  PAPER_PACKAGE = 21, //套卷
  /** @deprecated */
  EBOOK = 22, // 电子书
}
export const ShopType = {
  [ShopTypeEnum.NONE]: '',
  [ShopTypeEnum.OTO_CLASS]: '一对一',
  [ShopTypeEnum.NORMAL_COURSE]: '普通课程',
  [ShopTypeEnum.CLASS_COURSE]: '班级课程',
  [ShopTypeEnum.PUBLIC_CLASS]: '公开课',
  [ShopTypeEnum.VIDEO_CLASS]: '点播课', //废弃了 暂保留
  [ShopTypeEnum.FACE_CLASS]: '面授课', //废弃了 暂保留
  [ShopTypeEnum.AUDIO_CLASS]: '音频课', //废弃了 暂保留
  [ShopTypeEnum.SYSTEM_CLASS]: '系统课', //废弃了 暂保留
  [ShopTypeEnum.PICTURE_CLASS]: '图文课', //废弃了 暂保留
  [ShopTypeEnum.BALANCE]: '充值余额',
  [ShopTypeEnum.GOODS]: '商品',
  [ShopTypeEnum.LIBRARY]: '文库',
  [ShopTypeEnum.GROUP_CLASS]: '分组课',
  [ShopTypeEnum.DOUBLE_TEACHER_CLASS]: '线上双师课',
  [ShopTypeEnum.PERIODS_PACKAGE]: '课节包',
  [ShopTypeEnum.CLOCK_IN]: '打卡',
  [ShopTypeEnum.CLASSES]: '班级',
  [ShopTypeEnum.VIP]: '会员',
  [ShopTypeEnum.PAPER_PACKAGE]: '套卷',
};

export enum ShopStatusEnum {
  NONE = 0, // 空状态
  UNPAID = 1, // 待支付
  PAID = 2, // 已支付
  REFUND_APPLING = 3, // 退款中
  REFUNDING = 4, // 退款中
  REFUNDED = 5, // 已退款
  REFUND_FAIL = 6, // 退款失败
  REFUND_REFUSE = 7, // 退款拒绝
  REFUND_PART = 8, // 部分退款
  UNSHIP = 9, // 待发货
  SHIPED = 10, // 已发货
  CONFIRM_SHIP = 11, // 确认发货
  CANCEL = 12, //订单取消
}

export const ShopStatus = {
  [ShopStatusEnum.NONE]: '',
  [ShopStatusEnum.UNPAID]: '待支付',
  [ShopStatusEnum.PAID]: '已支付',
  [ShopStatusEnum.REFUND_APPLING]: '退款中',
  [ShopStatusEnum.REFUNDING]: '退款中',
  [ShopStatusEnum.REFUNDED]: '已退款',
  [ShopStatusEnum.REFUND_FAIL]: '退款失败',
  [ShopStatusEnum.REFUND_REFUSE]: '退款拒绝',
  [ShopStatusEnum.REFUND_PART]: '部分退款',
  [ShopStatusEnum.UNSHIP]: '待发货',
  [ShopStatusEnum.SHIPED]: '已发货',
  [ShopStatusEnum.CONFIRM_SHIP]: '确认发货',
  [ShopStatusEnum.CANCEL]: '订单取消',
};

export enum OrderButtonType {
  PAY = 1, //待支付
  CANCEL = 2, //取消
  REVISE_ADDRESS = 3, //修改地址
  VIEW_LOGISTICS = 4, //查看物流
  REFUND_APPLING = 5, //申请退款
  REFUND_RECORD = 6, //退款记录
}

export enum OrderMixStatusEnum {
  CLOSED = -1, // 已关闭
  UNPAID = 1, // 待支付
  GROUPING = 2, // 拼团中（待成团）
  COMPLETE = 3, // 已完成
  UNSHIP = 4, // 待发货
  SHIPED = 5, // 已发货
  REFUND_ALL = 6, // 全部退款（成功）
  REFUNDING = 7, // 退款中
  REFUND_FAIL = 8, // 退款失败
  REFUND_APPLING = 9, // 退款申请中
  REFUND_PART = 10, // 部分退款
  SHIP_PART = 11, // 部分发货
}

export enum HttpCodeEnum {
  LOGIN_FAIL = 202, // 登录失败
  ORDER_EXIST = 203, // 订单已存在
  REPEAT_PURCHASE = 2002, // 重复购买
}

export enum PaymentTypeEnum {
  ALI_PAY = 'aliPay',
  WX_PAY = 'wxPay',
  ALI_PAY_HUA_BEI = 'aliPayHuaBei',
}

export enum PayOrderTypeEnum {
  Trading = 1, // 交易中
  Complete = 2, // 交易完成
  Cancel = 3, // 交易取消或超时
}

export const PaymentTypeOptions = [
  {
    type: PaymentTypeEnum.WX_PAY,
    label: '微信支付',
    icon: wxPayIcon,
  },
  {
    type: PaymentTypeEnum.ALI_PAY,
    label: '支付宝支付',
    icon: aliPayIcon,
  },
  {
    type: PaymentTypeEnum.ALI_PAY_HUA_BEI,
    label: '花呗分期',
    icon: aliPayHuaBeiIcon,
  }
];

export const wxSdkUrl = 'https://cdn.yuaiweiwu.com/fe/test/bjy-wrap-yuaiweiwu/jweixin-1.6.0.js';

export const cookieOpenIdKey = 'user_center_h5_openid';
export const cookieUnionIdKey = 'user_center_h5_unionid';
export const cookieMobileKey = 'user_center_mobile';
// 退款单状态
export enum RefundOrderStatusEnum {
  NONE = 0, // 无
  APPLYING = 1, // 退款申请中
  SUCCESS = 2, // 退款成功
  CANCEL = 3, // 取消申请
  FAIL = 4, // 退款失败
  REFUSE = 5, // 退款被驳回
  REFUNDING = 6, //退款中
}

export const RefundOrderStatus = {
  [RefundOrderStatusEnum.NONE]: '',
  [RefundOrderStatusEnum.APPLYING]: '退款申请中',
  [RefundOrderStatusEnum.SUCCESS]: '退款成功',
  [RefundOrderStatusEnum.CANCEL]: '取消申请',
  [RefundOrderStatusEnum.FAIL]: '退款失败',
  [RefundOrderStatusEnum.REFUSE]: '退款被驳回',
  [RefundOrderStatusEnum.REFUNDING]: '退款中',
};

export enum CourseDetailTabEnum {
  CourseDesc = '课程介绍',
  CourseAbout = '课程大纲',
  CourseContain = '包含课程',
}

export enum CourseTabKeyEnum {
  CourseDesc = 'course-introduce',
  CourseAbout = 'course-outline',
  CourseContain = 'course-contain',
}

// 打开app scheme
export const appScheme = 'aienglish://';

export enum CourseShowStatusEnum {
  SHOW = 1, // 上架
  NOT_SHOW = 2, // 下架
  SHOW_AND_NOT_SELL = 3, // 上架且不可售卖（待上架）
}

export enum PayFromPage {
  CourseDetail = 'course-detail', // 课程详情页
  PackageCourseDetail = 'package-course-detail', // 组合课程详情页
  ActiveCoursePage = 'active-course-page', // 活动课程页
}

export const DEFAULT_INFO = {
  DESC: '快来体验AI 1对1导师吧',
  ICON: 'https://cdn.yuaiweiwu.com/fe/imgs/e20e7ae0-ad64-11f0-9c8e-f52b0c497d28-aixue-logo.png',
}

export enum WX_SHARE_TYPE_IN_APP {
  WEBPAGE = 'webpage',
  IMAGE = 'image',
  TEXT = 'text',
  VIDEO = 'video',
  MINI_PROGRAM = 'mini_program',
}